<div class="contenedor-modal-home">
    <div class="row">
        <div class="col-md-12 col-sm-12 text-center">
            <!-- <img src="assets/images/logo_colina.png" width="160px" height="90px"> -->
            <img class="logo-muni-modal" src="assets/images/generico/logo.png"> 
        </div>
        <div class="col-md-12 col-sm-12 text-center">
            <img class="linea" src="assets/images/linea-colores.jpg">
        </div>
        <div class="col-md-12 col-sm-12">

            <div class="card card-container">
                <img id="profile-img" class="profile-img-card" src="assets/images/photo.jpg" />
                <p id="profile-name" class="profile-name-card"></p>

                <input type="hidden" name="p" value="rut_find" />
                <form [formGroup]="user">
                    <div>
                        <h4>Identificaci&oacute;n del solicitante</h4>
                        <h5 class="form-signin-heading">Ingrese el RUT del Solicitante y la contrase&ntilde;a, luego
                            presione "Ingresar"</h5>
                    </div>
                    <mat-form-field class="input-form">
                        <input matInput placeholder="Rut" id="rut" name="rut" formControlName="rut" formatRut
                            [errorStateMatcher]="matcher">
                        <mat-error *ngIf="user.controls?.rut.hasError('required')">
                            Este campo es <strong>obligatorio</strong>
                        </mat-error>
                        <mat-error *ngIf="user.controls?.rut.hasError('invalidRut')">
                            Este rut es <strong>invalido</strong>
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="input-form" style="padding-top: 10px">
                        <input matInput placeholder="Contraseña" type="password" id="password" name="password"
                            formControlName="password" [errorStateMatcher]="matcher">
                        <mat-error *ngIf="user.controls?.password.hasError('required')">
                            Este campo es <strong>obligatorio</strong>
                        </mat-error>
                    </mat-form-field>
                    <!--<div id="remember" class="checkbox">
                            <label>
                                <input type="checkbox" value="remember-me"> Recordar
                            </label>
                        </div>-->

                    <button mat-raised-button color="primary" class="btn-login" id="login" [disabled]="!user.valid"
                        (click)="login(user)">
                        Ingresar
                        <mat-icon aria-label="icon">input</mat-icon>
                    </button>
                    <!-- <div align="center">
                        <div class="claveUnicaImg">
                            <input type="image" class="imagen" src="/assets/images/claveunica.png" border="0" (click)="claveunica()" disabled   />
                        </div>
                    </div> -->
                </form>
                <div id="links_users">
                    <a (click)="register()"  style="cursor: pointer;">Registrarse</a> |
                    <a (click)="openPass()"  style="cursor: pointer;">¿Olvid&oacute; su contrase&ntilde;a?</a> |
                <!--  <a *ngIf="!user.controls?.rut.hasError('invalidRut') && !user.controls?.rut.hasError('minlength')"
                        (click)="openResend()"  style="cursor: pointer;">Solicitar
                        nuevo
                        correo de Confirmaci&oacute;n</a> -->
                </div>

                <!--<a href="#" class="forgot-password">
                    Forgot the password?
                </a>-->
            </div>
        </div>
        
    </div>
</div>

<ng-template #openModal>
    <h2 mat-dialog-title>Ingresa a tu clave única</h2>
    <mat-dialog-content>
        <iframe frameborder="0" width="400px" height="400px" [src]="url"></iframe>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet"
            data-dismiss="modal">Cancelar</button>

    </mat-dialog-actions>
</ng-template>
<ng-template #openModalResend>
    <h2 mat-dialog-title>Ingresa tu correo</h2>
    <mat-dialog-content>
        <mat-form-field class="input-form">
            <input matInput placeholder="Correo" type="email" name="correo" id="correo" [(ngModel)]="mail" />
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="cancel_mail" data-dismiss="modal">Cancelar</button>
        <button mat-raised-button color="primary" id="ingreso_ampliacion" (click)="resendMail()">Enviar <i
                class="fa fa-user-o " aria-hidden="true "></i></button>
    </mat-dialog-actions>
</ng-template>





<ng-template #openResetPass>
    <h1 mat-dialog-title class="titleDialog">
        Recuperar contraseña.
    </h1>
    <div mat-dialog-content class="contentDialog">
        <p>Para recuperar su contraseña, por favor ingrese su email.</p>
    </div>
    <mat-dialog-content>
        <form [formGroup]="new">
            <mat-form-field class="inputlogin">
                <input matInput placeholder="Rut" id="rut" name="rut" formControlName="rut" formatRut
                    [errorStateMatcher]="matcher" minlength="8">
                <mat-error *ngIf="new.controls?.rut.hasError('required')">
                    Este campo es <strong>obligatorio</strong>
                </mat-error>
                <mat-error *ngIf="new.controls?.rut.hasError('invalidRut')">
                    Este rut es <strong>invalido</strong>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="input-form">
                <input matInput placeholder="Correo" type="email" name="correo" formControlName="email" onpaste="return false;" onCopy="return false"/>
                <mat-error *ngIf="new.controls.email.errors?.required">Email requerido
                </mat-error>
                <mat-error *ngIf="new.controls.email.errors?.pattern">Formato incorrecto.
                    Ej:
                    correo@servidor.dominio. </mat-error>
                <mat-error *ngIf="new.controls.email.errors?.maxlength">Excede el máximo de
                    caracteres
                    (50). </mat-error>
                <mat-error *ngIf="new.controls?.email.errors?.match">
                    Los emails deben <strong>conincidir</strong>.
                </mat-error>
            </mat-form-field>
            <mat-form-field class="input-form">
                <input matInput placeholder="Repetir Correo" type="email" name="correo" formControlName="repeatEmail" onpaste="return false;" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false" autocomplete=off/>
                <mat-error *ngIf="new.controls.repeatEmail.errors?.required">Email requerido
                </mat-error>
                <mat-error *ngIf="new.controls.repeatEmail.errors?.pattern">Formato incorrecto.
                    Ej:
                    correo@servidor.dominio. </mat-error>
                <mat-error *ngIf="new.controls.repeatEmail.errors?.maxlength">Excede el máximo de
                    caracteres
                    (50). </mat-error>
                <mat-error *ngIf="new.controls?.repeatEmail.errors?.match">
                    Los emails deben <strong>conincidir</strong>.
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="cancel_mail" data-dismiss="modal" (click)="dialog.closeAll()">Cancelar</button>
        <button mat-raised-button color="primary" id="ingreso_ampliacion" [disabled]="new.status == 'INVALID'"
            (click)="submitRepeatPass()">Enviar </button>
    </mat-dialog-actions>
</ng-template>



<ng-template #mailResp>
    <h2 mat-dialog-title>Correo de recuperación</h2>
    <mat-dialog-content>
        <p>Se a enviado un correo con los pasos a seguir al correo indicado.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="cancel_mail" data-dismiss="modal" (click)="dialog.closeAll()">Aceptar</button>

    </mat-dialog-actions>
</ng-template>


<ng-template #mailNoResp>
    <h2 mat-dialog-title>Correo de recuperación</h2>
    <mat-dialog-content>
        <p>Ha ocurrido un problema con el envio de su correo de recuperación de clave.</p>
        <p>Por favor, intente más tarde.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="cancel_mail" data-dismiss="modal" (click)="dialog.closeAll()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>
